export enum MenuMessages {
  production = "menu.production",
  pumps = "menu.pumps",
  supportVehicles = "menu.supportVehicles",
  trucks = "menu.trucks",
  dashboards = "menu.dashboards",
  management = "menu.management",
  users = "menu.users",
  modules = "menu.modules",
  drivers = "menu.drivers",
  vehicles = "menu.vehicles",
  locations = "menu.locations",
  hardwares = "menu.hardwares",
  SIMCards = "menu.SIMCards",
  reports = "menu.reports",
  scheduledReports = "menu.scheduledReports",
  travelHistory = "menu.travelHistory",
  alertHistory = "menu.alertHistory",
  averageSpeed = "menu.averageSpeed",
  coordinateAnalysis = "menu.coordinateAnalysis",
  vehicleHistory = "menu.vehicleHistory",
  vehicleCanHistory = "menu.vehicleCanHistory",
  vehicleStatesHistory = "menu.vehicleStatesHistory",
  waterAdditionHistory = "menu.waterAdditionHistory",
  canHistory = "menu.canHistory",
  odometerHourmeterReport = "menu.odometerHourmeterReport",
  others = "menu.others",
  contactUs = "menu.contactUs",
  settings = "menu.settings",
  installApp = "menu.installApp",
  exit = "menu.exit",
  generalLocation = "menu.generalLocation",
  vehiclesUnderMaintenance = "menu.vehiclesUnderMaintenance",
  alerts = "menu.alerts",
  speedingAlerts = "menu.speedingAlerts",
  canAlerts = "menu.canAlerts",
  concreteExpiration = "menu.concreteExpiration",
  improperDischarges = "menu.improperDischarges",
  vehiclesInTrustedLocations = "menu.vehiclesInTrustedLocations",
  blockedVehicles = "menu.blockedVehicles",
  regionals = "menu.regionals",
  groups = "menu.groups",
  help = "menu.help",
  pumpProgramming = "menu.pumpProgramming",
  relatedMixersDetails = "menu.relatedMixersDetails",
  zones = "menu.zones",
  driversRoles = "menu.driversRoles",
  travelAnalysis = "menu.travelAnalysis",
  registration = "menu.registration",
  operation = "menu.operation",
  equipment = "menu.equipment",
  administration = "menu.administration",
  documentation = "menu.documentation",
  support = "menu.support",
  docsManual = "menu.docsManual",
  reportsTravel = "menu.reportsTravel",
  reportsVehicle = "menu.reportsVehicle",
  reportsMonitoring = "menu.reportsMonitoring",
  reportsRequested = "menu.reportsRequested"
}

export type TranslationMenuMessages = {
  [key in MenuMessages]: string;
}
